import "./AboutUs.module.css";
import Header from "@/reusable_sections/Header";
import AboutUs from "./sections/AboutUs";
import Gallery from "./sections/Gallery";
import Otzyvi from "./sections/Otzyvi";
import Footer from "@/reusable_sections/Footer";
import OperatingHours from "./sections/OperatingHours";
export default function AboutUsPage() {
  return <div>
      <Header />
      <AboutUs />
      <OperatingHours />
      <Gallery />
      <Otzyvi />
      <Footer />
    </div>;
}